import React, { useState } from 'react';
import Icon from '../common/Icon';
import { grabFieldNames } from './constants/globalSearch';
import SingleMailerModal from '../mailers/SingleMailerModal';
import dayjs from 'dayjs';

const FormSubmissionsSearch = ({ form, mailers, userCanWrite }) => {
  const max = form.submissions.length;
  const selectableMailers = userCanWrite
    ? mailers
    : mailers.filter((m) => m.universal_mail_send);
  const [slice, setSlice] = useState({ start: 0, end: 25 });
  const [viewMailSend, setViewMailSend] = useState(false);
  const [selectedSubId, setSelectedSubId] = useState(null);

  const handleModalClose = () => {
    setSelectedSubId(null);
    setViewMailSend(false);
  };

  const handleOpenMailerModal = (subId) => {
    setSelectedSubId(subId);
    setViewMailSend(true);
  };

  return (
    <table>
      <thead>
        <tr>
          <th>
            <Icon
              isLink
              url={`/manage/forms/${form.id}`}
              target='_blank'
              icon='external-link'
              title='Go to Form'
            />
            <span>{form.name}</span>
          </th>
          <th style={{ width: form.informant ? '40%' : '55%' }}>Field Names</th>
          {form.informant && (
            <th style={{ width: '25%' }}>Quota Field: {form.informant}</th>
          )}
          <th>
            Submitted{' '}
            <div className='right'>
              {slice.start != 0 && (
                <i
                  className='fa-solid fa-arrow-left fa-lg'
                  onClick={() =>
                    setSlice({ start: slice.start - 25, end: slice.end - 25 })
                  }
                />
              )}

              <span>
                {max <= 25
                  ? max
                  : `${slice.start + 1}-${
                      slice.end > max ? max : slice.end
                    }`}{' '}
                of {max}
              </span>

              {slice.end < max && (
                <i
                  className='fa-solid fa-arrow-right fa-lg'
                  onClick={() =>
                    setSlice({ start: slice.start + 25, end: slice.end + 25 })
                  }
                />
              )}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {form.submissions.slice(slice.start, slice.end).map((sub) => (
          <tr key={sub.id} className='ignore-hover'>
            <td>
              ID: {sub.id}{' '}
              <div className='right'>
                <Icon
                  isLink
                  url={`/manage/submissions/${sub.id}`}
                  icon='external-link'
                  title='Go to Submission'
                  target='_blank'
                />
                <Icon
                  icon='envelope'
                  onClick={() => handleOpenMailerModal(sub.id)}
                  title='Send Mail'
                />
              </div>
            </td>
            <td>{grabFieldNames(form.fields, sub)}</td>
            {form.informant && <td>{sub.informant_response?.option}</td>}
            <td>{dayjs(sub.created_at).format('MM/DD/YYYY')}</td>
          </tr>
        ))}
      </tbody>

      <SingleMailerModal
        mailers={selectableMailers}
        viewMailSend={viewMailSend}
        closeModal={handleModalClose}
        submissionId={selectedSubId}
        sendingFromGlobal={true}
        updateDeliveries={() => {}}
      />
    </table>
  );
};

export default FormSubmissionsSearch;
